module.exports = __webpack_public_path__ + "img/AL273LS-1.893f1831.jpg";